import React, { useState } from 'react';

const DateOfBirthInput = ({ day, month, year, onDateChange }) => {
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const months = Array.from({ length: 12 }, (_, i) => i + 1);
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
    const [date, setDate] = useState([day, month, year]);

    const handleChange = (value, index) => {
        value = parseInt(value, 10); // Parse the input value as an integer
        const updatedDate = [...date]; // Create a new copy of the array
        updatedDate[index] = value; // Update the specific index
        setDate(updatedDate); // Set the new state
        console.log('Updated date:', updatedDate); // Log the updated date
        onDateChange(updatedDate[0], updatedDate[1], updatedDate[2]); // Use the updated date
    };

    return (
        <div className="info-input">
            <select value={date[0] || ''} onChange={(e) => handleChange(e.target.value, 0)}>
                <option value="" disabled>Day</option>
                {days.map((d) => (
                    <option key={d} value={d}>{d}</option>
                ))}
            </select>

            <select value={date[1] || ''} onChange={(e) => handleChange(e.target.value, 1)}>
                <option value="" disabled>Month</option>
                {months.map((m) => (
                    <option key={m} value={m}>{m}</option>
                ))}
            </select>

            <select value={date[2] || ''} onChange={(e) => handleChange(e.target.value, 2)}>
                <option value="" disabled>Year</option>
                {years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                ))}
            </select>
        </div>
    );
};

export default DateOfBirthInput;
